import { render, staticRenderFns } from "./GroupFeesTable.vue?vue&type=template&id=2108cfdb"
import script from "./GroupFeesTable.vue?vue&type=script&lang=js"
export * from "./GroupFeesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports